import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import headLogo from '../../assets/head-logo.png';

const Copyright = () => {
  const { t } = useTranslation();

  return (
    <div className="text-gray-500 text-xs">
      {/* 第一行：DecisionAI和猎豹移动的版权信息 */}
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-2">
        <span>{t('footer.decisionAICopyright')}</span>
        <span className="hidden sm:inline">•</span>
        <span>{t('footer.copyright')}</span>
        <span className="hidden sm:inline">•</span>
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-white transition-colors break-all sm:break-normal"
        >
          京ICP备12038800号-7【京B2-20221410】
        </a>
        <span className="hidden sm:inline">|</span>
        <span className="flex items-center gap-1">
          <img
            src={headLogo}
            alt="备案图标"
            className="w-3 h-3 object-contain"
          />
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502030117"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors"
          >
            京公网安备 11010502030117号
          </a>
        </span>
        <span className="hidden sm:inline">|</span>
        <a
          href="https://www.orionstar.com/privacy.html"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-white transition-colors"
        >
          {t('footer.privacyPolicy')}
        </a>
      </div>
    </div>
  );
};

export default Copyright;